import { createContext, useContext } from 'react';
import type { MidiHit, MidiStatus } from '../hooks/useMidiDrums';

export interface MidiContextValue {
  status: MidiStatus;
  deviceName: string;
  lastHit: MidiHit | null;
  scan: () => void;
}

export const MidiContext = createContext<MidiContextValue>({
  status: 'idle',
  deviceName: '',
  lastHit: null,
  scan: () => {},
});

export function useDrumMidi() {
  return useContext(MidiContext);
}
